export const animations = {
  '@keyframes wiggle': {
    '0%': { transform: 'translate(2px, 0)' },
    '50%': { transform: 'translate(-2px, 0)' },
    '100%': { transform: 'translate(2px, 0)' },
  },
}
